import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid2, TextField, Typography } from '@mui/material';
import { minimumPaymentAmount } from '../../../../../config';

function CashPaymentBlock({ onCancel, paymentMethod, onStartTransaction, amount, maxAmount }) {
    const [note, setNote] = useState('');
    const { t } = useTranslation();
    return (
        <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12 }}>
                <Typography variant="h6">
                    {paymentMethod.name} {t('paymentmethods.paymentBlock')}
                </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <Grid2>
                    <Typography variant="subtitle2">
                        {t('widgetReservationInfo.paymentMethods.note')}
                    </Typography>
                    <Grid2>
                        <TextField
                            fullWidth
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        />
                    </Grid2>
                </Grid2>
            </Grid2>
            <Grid2 container size={{ xs: 12 }}>
                {onCancel && (
                    <Grid2 size={{ xs: 6 }}>
                        <Button fullWidth onClick={onCancel}>
                            {t('common.cancel')}
                        </Button>
                    </Grid2>
                )}
                <Grid2 size={{ xs: 6 }}>
                    <Button
                        fullWidth
                        onClick={() => {
                            onStartTransaction({
                                note,
                            });
                        }}
                        // cannot do a split if less than 1 usd is one of the parts (either the one paid or the remaining portion)
                        disabled={
                            amount && maxAmount
                                ? amount < minimumPaymentAmount ||
                                  (maxAmount - amount < minimumPaymentAmount &&
                                      amount !== maxAmount)
                                : false
                        }
                    >
                        {t('common.pay')}
                    </Button>
                </Grid2>
            </Grid2>
        </Grid2>
    );
}

export default CashPaymentBlock;
